import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const BeneficiaryAppInfo = (props) => {
    const { editMode, beneDetail, allCurrentLevel, schoolList, getPicklistBene } = props;

    const allApplicationStatus = getPicklistBene('Application_Status__c')
    const allApplicationType = getPicklistBene('Application_Status__c')
    const allStream = getPicklistBene('Stream__c')

    return (
        <div className="x_content" style={{ display: 'block' }} >
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Applying to</label>
                    <ReactSelect
                        options={schoolList}
                        isDisabled={!editMode}
                        onChange={(val) => {
                            props.onFormChanged('multiStateChangeBene', {
                                Current_School__r: val.value,
                                Applying_to__r: val.value,
                                Current_Level__c: ''
                            });
                        }}
                        value={beneDetail.Applying_to__r ? { value: beneDetail.Applying_to__r.Id, label: beneDetail.Applying_to__r.Name } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>Referred From</label>
                    <ReactSelect
                        options={schoolList}
                        isDisabled={!editMode}
                        onChange={(val) => {
                            props.onFormChanged('multiStateChangeBene', {
                                Referred_From__r: val.value,
                            });
                        }}
                        value={beneDetail.Referred_From__r ? { value: beneDetail.Referred_From__r.Id, label: beneDetail.Referred_From__r.Name } : {}}
                    />
                </div>
                <div className="form-group">
                    <label>Referred Date</label>
                    <DatePicker
                        name={`Referred_Date__c`}
                        dateFormat="YYYY-MM-DD"
                        className="form-control fullw"
                        selected={beneDetail.Referred_Date__c ? moment(beneDetail.Referred_Date__c) : null}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={moment()}
                        disabled={!editMode}
                        onChange={val => props.onFormChanged('Referred_Date__c', val)}
                    />
                </div>
                <div className="form-group">
                    <label>Referring Reason</label>
                    <input
                        type="text"
                        className="form-control"
                        value={beneDetail ? beneDetail.Referring_Reason__c || '' : ''}
                        disabled={!editMode}
                        onChange={e => props.onFormChanged('Referring_Reason__c', e.target.value)}
                    />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Application Type</label>
                    <ReactSelect
                        options={allApplicationType}
                        onChange={val => props.onFormChanged('Application_Type__c', val.value)}
                        value={{ label: beneDetail.Application_Type__c, value: beneDetail.Application_Type__c }}
                        isDisabled={!editMode}
                    />
                </div>
                <div className="form-group">
                    <label>Status</label>
                    <ReactSelect
                        options={allApplicationStatus}
                        onChange={val => props.onFormChanged('Application_Status__c', val.value)}
                        value={{ label: beneDetail.Application_Status__c, value: beneDetail.Application_Status__c }}
                        isDisabled={true}
                    />
                </div>
                <div className="form-group">
                    <label>Current Level</label>
                    <ReactSelect
                        options={allCurrentLevel}
                        onChange={val => props.onFormChanged('Current_Level__c', val.value)}
                        value={{ label: beneDetail.Current_Level__c, value: beneDetail.Current_Level__c }}
                        isDisabled={!editMode}
                    />
                </div>
                <div className="form-group">
                    <label>Stream</label>
                    <ReactSelect
                        options={allStream}
                        onChange={val => props.onFormChanged('Stream__c', val.value)}
                        value={{ label: beneDetail.Stream__c, value: beneDetail.Stream__c }}
                        isDisabled={!editMode}
                    />
                </div>
            </div>
        </div>
    );
};

BeneficiaryAppInfo.defaultProps = {
    editMode: false,
};

BeneficiaryAppInfo.propTypes = {
    editMode: PropTypes.bool,
    beneDetail: PropTypes.object.isRequired,
};


export default BeneficiaryAppInfo;




//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/components/BeneficiaryAppInformation.js
// module id = 892
// module chunks = 0